// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__MS2AC","textarea":"MessageSender_textarea__JzUta","button":"MessageSender_button__pEqTi"};